import { useMutation } from "react-query";
import { WorkspaceDownloadFileData } from "@interfaces/company/workspace";
import { workspaceService } from "@services/workspace-service";

export const useDownloadWorkspaceFileMutation = () => {
  return useMutation((data: WorkspaceDownloadFileData) =>
    workspaceService.downloadFile(data)
  );
};
